import React from 'react';
import Slider from 'react-slick';
import './LogoCarousel.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const LogoCarousel = ({ logos = [], heading = 'Clients Worldwide' }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 8000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    arrows: false,
    pauseOnHover: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 900, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="logo-carousel-section">
      <h2 className="logo-carousel-heading">{heading}</h2>
      <div className="logo-carousel-container">
        <Slider {...settings}>
  {logos.map((logo, idx) => (
    <div key={idx} className="logo-slide">
      <div className="logo-slide-inner">
        <img src={logo.src} alt={logo.alt} className="client-logo" />
      </div>
    </div>
  ))}
</Slider>
      </div>
    </section>
  );
};

export default LogoCarousel;
